export const CHAT_OPTIONS = {
  APP: "APP",
  WEB: "WEB",
};
